export enum DailyTaxFileStatus {
    New = 0,
    Posted = 1,
    Failed = 2
}